module.exports = "/work-site/img/qrCode.08a31577.png";